import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import {
  AppEntriesParams,
  UseDynamicAppAndBasename,
} from '@/apps/root.interface';

export const useDynamicAppAndBasename: UseDynamicAppAndBasename = ({
  basename,
  entries,
}) => {
  const location = useLocation();

  const basenameMatch = useMemo(
    () => {
      const validBasenamePattern = basename
        ? [`${basename}/:appName`, '/:appName']
        : '/:appName';

      return matchPath<AppEntriesParams>(location.pathname, {
        path: validBasenamePattern,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const appComponent = useMemo(() => {
    const matchedEntry = entries.find(
      entry => entry.appName === basenameMatch?.params.appName,
    );
    return matchedEntry?.appComponent;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    app: appComponent,
    basenameWithAppName: basenameMatch?.url,
  };
};
